import React, { useState, useEffect } from "react";
import {
  Navbar,
  Form,
  InputGroup,
  Button,
  Dropdown,
  Image,
} from "react-bootstrap";
import "./index.scss";
import logo from "../../../assets/images/logoF.png";
import logo1 from "../../../assets/images/logo-a.png";
export default function Header({ onToggleSidebar, isSidebarOpen }) {
  const [isMobile, setIsMobile] = useState(false);

  // Détection resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // mobile si écran ≤ 768px
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Navbar className="app-header p-3 d-flex align-items-center justify-content-between">
      <div className="d-flex align-items-center gap-3">
        {" "}
        {/* Left - Hamburger toujours visible */}
        <Button
          variant="link"
          className="menu-btn p-0"
          onClick={onToggleSidebar}>
          {isSidebarOpen ? (
            // Icône CLOSE (X)
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none">
              <path
                d="M18 6L6 18M6 6l12 12"
                stroke="#667085"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ) : (
            // Icône BURGER
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="14"
              viewBox="0 0 16 12"
              fill="none">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.583984 1C0.583984 0.585788 0.91977 0.25 1.33398 0.25H14.6673C15.0815 0.25 15.4173 0.585786 15.4173 1C15.4173 1.41421 15.0815 1.75 14.6673 1.75H1.33398C0.91977 1.75 0.583984 1.41422 0.583984 1ZM0.583984 11C0.583984 10.5858 0.91977 10.25 1.33398 10.25H14.6673C15.0815 10.25 15.4173 10.5858 15.4173 11C15.4173 11.4142 15.0815 11.75 14.6673 11.75H1.33398C0.91977 11.75 0.583984 11.4142 0.583984 11ZM1.33398 5.25C0.91977 5.25 0.583984 5.58579 0.583984 6C0.583984 6.41421 0.91977 6.75 1.33398 6.75H8.00065C8.41486 6.75 8.75065 6.41421 8.75065 6C8.75065 5.58579 8.41486 5.25 8.00065 5.25H1.33398Z"
                fill="#667085"
              />
            </svg>
          )}
        </Button>
        {/* Search visible seulement sur desktop */}
        {!isMobile && (
          <Form className="search-box mx-auto">
            <InputGroup>
              <InputGroup.Text className="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.04102 9.37363C3.04102 5.87693 5.87638 3.04199 9.37435 3.04199C12.8724 3.04199 15.7077 5.87693 15.7077 9.37363C15.7077 12.8703 12.8724 15.7053 9.37435 15.7053C5.87638 15.7053 3.04102 12.8703 3.04102 9.37363ZM9.37435 1.54199C5.04829 1.54199 1.54102 5.04817 1.54102 9.37363C1.54102 13.6991 5.04829 17.2053 9.37435 17.2053C11.2667 17.2053 13.0023 16.5344 14.3563 15.4176L17.1763 18.238C17.4692 18.5309 17.9441 18.5309 18.237 18.238C18.5299 17.9451 18.5299 17.4703 18.237 17.1774L15.4173 14.3573C16.5358 13.0033 17.2077 11.2669 17.2077 9.37363C17.2077 5.04817 13.7004 1.54199 9.37435 1.54199Z"
                    fill="#667085"
                  />
                </svg>
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Search or type command..."
              />
              <InputGroup.Text className="shortcut">⌘ K</InputGroup.Text>
            </InputGroup>
          </Form>
        )}
      </div>

      {isMobile && (
        <div className="sidebar-logo  d-flex align-items-center">
          <div>
            <img src={logo1} alt="logo-mini" />
          </div>

          <span className="logo-text ms-2">
            <img src={logo} alt="logo-full" />
          </span>
        </div>
      )}

      {/* Right actions */}
      <div className="d-flex align-items-center gap-3">
        {!isMobile && (
          <div className="notification-wrapper">
            <Button variant="link" className="p-0 icon-btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none">
                {" "}
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.7506 2.29248C10.7506 1.87827 10.4149 1.54248 10.0006 1.54248C9.58644 1.54248 9.25065 1.87827 9.25065 2.29248V2.83613C6.08327 3.20733 3.62565 5.9004 3.62565 9.16748V14.4591H3.33398C2.91977 14.4591 2.58398 14.7949 2.58398 15.2091C2.58398 15.6234 2.91977 15.9591 3.33398 15.9591H4.37565H15.6256H16.6673C17.0815 15.9591 17.4173 15.6234 17.4173 15.2091C17.4173 14.7949 17.0815 14.4591 16.6673 14.4591H16.3756V9.16748C16.3756 5.9004 13.918 3.20733 10.7506 2.83613V2.29248ZM14.8756 14.4591V9.16748C14.8756 6.47509 12.693 4.29248 10.0006 4.29248C7.30826 4.29248 5.12565 6.47509 5.12565 9.16748V14.4591H14.8756ZM8.00065 17.7085C8.00065 18.1228 8.33644 18.4585 8.75065 18.4585H11.2506C11.6649 18.4585 12.0006 18.1228 12.0006 17.7085C12.0006 17.2943 11.6649 16.9585 11.2506 16.9585H8.75065C8.33644 16.9585 8.00065 17.2943 8.00065 17.7085Z"
                  fill="#667085"
                />{" "}
              </svg>
            </Button>
            <span className="dot"></span>
          </div>
        )}

        <Dropdown align="end">
          {/* <Dropdown.Toggle as="div" className="user-dropdown">
            <Image
              src="https://via.placeholder.com/32"
              roundedCircle
              className="me-2"
            />
            {!isMobile && <span>Musharof</span>}
            <FaChevronDown className="ms-1" size={12} />
          </Dropdown.Toggle> */}

          <Dropdown.Menu>
            <Dropdown.Item>Profile</Dropdown.Item>
            <Dropdown.Item>Settings</Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item>Logout</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </Navbar>
  );
}
